import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { services } from '../data/mockData';
import { Heart, Camera, Coffee, Calendar, Gift } from 'lucide-react';

const MereFille = () => {
  const navigate = useNavigate();
  const mereFille = services.mereFille;

  const handleReserve = () => {
    navigate(`/reservation?service=${encodeURIComponent(mereFille.name)}`);
  };

  return (
    <div className="page-service">
      {/* Hero Header */}
      <section className="service-hero mere-fille-hero">
        <div className="service-hero-pattern" />
        <div className="service-hero-content">
          <div className="nouveaute-badge">NOUVEAUTÉ</div>
          <h1 className="service-hero-title">Moment détente</h1>
          <h2 className="service-hero-subtitle-large">Mère et Fille</h2>
          <Heart className="hero-icon" size={48} strokeWidth={1.5} />
        </div>
      </section>

      {/* Programme Section */}
      <section className="programme-section">
        <div className="container-service">
          <div className="programme-header">
            <h2 className="section-title">Au Programme</h2>
            <div className="decorative-line" />
          </div>

          <div className="programme-grid">
            {mereFille.includes.map((item, index) => {
              const icons = [
                <Gift key="gift" size={32} />,
                <Heart key="heart" size={32} />,
                <HandHeart key="hand" size={32} />,
                <Camera key="camera" size={32} />,
                <Coffee key="coffee" size={32} />
              ];
              
              return (
                <div key={index} className="programme-item">
                  <div className="programme-icon">
                    {icons[index] || <Heart size={32} />}
                  </div>
                  <p>{item}</p>
                </div>
              );
            })}
          </div>

          <div className="programme-note">
            <span className="note-icon">👘</span>
            <span>{mereFille.note}</span>
          </div>
        </div>
      </section>

      {/* Schedule Section */}
      <section className="schedule-section">
        <div className="container-service">
          <div className="schedule-card">
            <div className="schedule-header">
              <Calendar size={32} />
              <h3>Créneaux</h3>
            </div>
            
            <div className="schedule-grid">
              <div className="schedule-day">
                <h4>Mercredi</h4>
                {mereFille.schedule.mercredi.map((time, index) => (
                  <div key={index} className="schedule-time">{time}</div>
                ))}
              </div>
              <div className="schedule-day">
                <h4>Samedi</h4>
                {mereFille.schedule.samedi.map((time, index) => (
                  <div key={index} className="schedule-time">{time}</div>
                ))}
              </div>
              <div className="schedule-day">
                <h4>Dimanche</h4>
                {mereFille.schedule.dimanche.map((time, index) => (
                  <div key={index} className="schedule-time">{time}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing-section">
        <div className="container-service">
          <div className="pricing-card-large">
            <h3 className="pricing-title">Tarifs</h3>
            <div className="pricing-main">
              <span className="pricing-amount">{mereFille.price}€</span>
            </div>
            <div className="pricing-deposit">
              <span>Acompte de {mereFille.deposit}€ pour la réservation</span>
            </div>
          </div>

          <div className="info-box">
            <h4>Plus de renseignements et réserver en privé</h4>
            <div className="info-contact">
              <Heart className="info-icon" size={20} />
              <span>Contactez-nous pour réserver votre moment privilégié</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <div className="service-cta-content">
          <h3 className="service-cta-title">Partagez un moment unique ensemble</h3>
          <p className="service-cta-text">
            Un instant de complicité et de détente à partager entre mère et fille
          </p>
          <Link to="/reservation" className="btn-primary" onClick={(e) => { e.preventDefault(); handleReserve(); }}>
            Réserver maintenant
          </Link>
        </div>
      </section>
    </div>
  );
};

// Fix import
import { HandHeart } from 'lucide-react';

export default MereFille;
